/**
 * Catalogued ops event types for intentional logger beacons.
 * Prefer these over free-text-only logs when something will be dashboarded.
 *
 * RUM custom-event type pattern: [\w\-:/.#\[\]]+
 */

export const LOG_EVENT_TYPES = Object.freeze({
    /** User-visible React ErrorBoundary fallback (PRD-2906). */
    ERROR_BOUNDARY: 'com.lyt.portal.error_boundary',
    /** Structured view-layer traceability event. */
    VIEW: 'com.lyt.portal.view',
    /** Structured business-operation traceability event. */
    OPERATION: 'com.lyt.portal.operation',
    /** Structured service-boundary traceability event. */
    SERVICE: 'com.lyt.portal.service',
    /** Structured UI-flow performance event. */
    PERFORMANCE: 'com.lyt.portal.performance',
    /** Generic error when no catalogued event_type is provided. */
    LOG_ERROR: 'com.lyt.portal.log.error',
    /** Prefix for logger.performance(name) → com.lyt.portal.performance.<name> */
    PERFORMANCE_PREFIX: 'com.lyt.portal.performance.',
});
